import React, { useMemo } from 'react';
import {
  makeStyles, Button, Theme, useMediaQuery,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Routes from 'Routes';

import { guessDevice } from 'utils/browserUtils';
import ChromeIcon from '../icons/Chrome';
import ChromeInactiveIcon from '../icons/ChromeInactive';
import EdgeIcon from '../icons/Edge';
import EdgeInactiveIcon from '../icons/EdgeInactive';
import FirefoxIcon from '../icons/Firefox';
import FirefoxInactiveIcon from '../icons/FirefoxInactive';
import SafariIcon from '../icons/Safari';
import SafariInactiveIcon from '../icons/SafariInactive';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    color: '#fff',
    textAlign: 'center',
    justifyContent: 'center',
  },
  title: {
    fontFamily: 'Avenir',
    fontStyle: 'normal',
    fontWeight: 900,
    fontSize: '32px',
    lineHeight: '44px',
    textTransform: 'uppercase',
    [theme.breakpoints.down('sm')]: {
      fontSize: '22px',
      lineHeight: '30px',
      textTransform: 'initial',
    },
  },
  content: {
    fontFamily: 'Avenir',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '24px',
    lineHeight: '33px',
    marginTop: '12px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      lineHeight: '19px',
    },
  },
  icons: {
    display: 'flex',
    marginTop: '60px',
    marginBottom: '20px',
    justifyContent: 'center',

    '& > svg': {
      margin: '20px',
      [theme.breakpoints.down('sm')]: {
        margin: '10px',
      },
    },
  },
  button: {
    width: '136px',
    backgroundColor: '#D80C24',
    '&:hover': {
      backgroundColor: '#D80C24',
    },
  },
}));

export default function UnsupportedBrowserWarning() {
  const classes = useStyles();
  const { t } = useTranslation();
  const device = guessDevice();
  const history = useHistory();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const iconSize = useMemo(() => (isMobile ? ({
    width: 60,
    height: 60,
  }) : ({
    width: 88,
    height: 88,
  })), [isMobile]);
  const avaibleBrowsers = useMemo(() => {
    const browsers = {
      firefox: true,
      safari: true,
      chrome: true,
      edge: true,
    };
    switch (device) {
      case 'IOS': {
        browsers.edge = false;
        browsers.chrome = false;
        browsers.firefox = false;
        break;
      }
      case 'Android': {
        browsers.safari = false;
        browsers.edge = false;
        break;
      }
      case 'Windows': {
        browsers.safari = false;
        break;
      }
      case 'Linux': {
        browsers.edge = false;
        browsers.safari = false;
        break;
      }
      default:
        break;
    }
    return browsers;
  }, [device]);

  const onBackToLobbyBtnClick = () => {
    history.push(Routes.lobby);
  };

  return (
    <div className={classes.container}>
      <div className={classes.title}>
        {t('networking_lounge.unsupported_browser.title', 'You seem to be using an unsupported browser')}
      </div>
      <div className={classes.content}>
        {t('networking_lounge.unsupported_browser.description', 'please login to the new experience with a supported browser.')}
      </div>
      <div className={classes.icons}>
        {
          avaibleBrowsers.firefox ? <FirefoxIcon width={iconSize.width} height={iconSize.height} /> : <FirefoxInactiveIcon width={iconSize.width} height={iconSize.height} />
        }
        {
          avaibleBrowsers.safari ? <SafariIcon width={iconSize.width} height={iconSize.height} /> : <SafariInactiveIcon width={iconSize.width} height={iconSize.height} />
        }
        {
          avaibleBrowsers.chrome ? <ChromeIcon width={iconSize.width} height={iconSize.height} /> : <ChromeInactiveIcon width={iconSize.width} height={iconSize.height} />
        }
        {
          avaibleBrowsers.edge ? <EdgeIcon width={iconSize.width} height={iconSize.height} /> : <EdgeInactiveIcon width={iconSize.width} height={iconSize.height} />
        }
      </div>
      <div>
        <Button variant="contained" color="secondary" className={classes.button} onClick={onBackToLobbyBtnClick}>
          {t('networking_lounge.unsupported_browser.got_it', 'GOT IT')}
        </Button>
      </div>
    </div>
  );
}
